"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleSecretManagerSecretNames = void 0;
/**
 * Used for accessing secrets from the backend in cloud functions and also deployed containers.
 *
 */
exports.googleSecretManagerSecretNames = {
    cdnSigningKey: "cdn-signing-key-prod",
    githubAccessToken: "github-access-token",
    openAiGretelApiKey: "openai-gretel-dev-api-key",
    redshiftClusterHostname: "redshift-cluster-hostname",
    redshiftPassword: "redshift-password",
    redshiftUsername: "redshift-username",
    copilotLibrarianServiceUrl: "copilot-librarian-service-url",
};
//# sourceMappingURL=secretNames.js.map